import * as React from 'react';
import { cn } from '@/lib/utils';

/** A native checkbox with a label, so the hit target and the a11y name come free. */
export const Checkbox = React.forwardRef<
  HTMLInputElement,
  React.InputHTMLAttributes<HTMLInputElement> & { label?: React.ReactNode }
>(({ className, label, id, ...props }, ref) => {
  const generated = React.useId();
  const inputId = id ?? generated;
  return (
    <div className="flex items-start gap-2">
      <input
        id={inputId}
        ref={ref}
        type="checkbox"
        className={cn(
          'mt-0.5 h-4 w-4 shrink-0 rounded border-input text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
          className,
        )}
        {...props}
      />
      {label !== undefined && (
        <label htmlFor={inputId} className="text-sm leading-snug">
          {label}
        </label>
      )}
    </div>
  );
});
Checkbox.displayName = 'Checkbox';
